export default {
  title: "Support",
  instruction: "User guide of Exhibitor portal",
  callcentreTitle: "Call Centre",
  searchPlaceholder: "Search...",
  askQuestionBtn: "Ask a question",
  nothingFound: "No results.",
  showMore: "Show more Q&A",
  howToTitle: "Learn more about Expocentre"
};
